import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ResetIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd">
        <rect fill="#ffffff" className={styles.white} height="16" opacity="0" width="16" />
        <path
          d="M7.5,7.5 L3.5,3.5 L7.5,-0.5 L7.50067087,2.51889382 C7.66547272,2.50637415 7.83199198,2.5 8,2.5 C11.5898509,2.5 14.5,5.41014913 14.5,9 C14.5,12.5898509 11.5898509,15.5 8,15.5 C4.41014913,15.5 1.5,12.5898509 1.5,9 C1.5,8.83199198 1.50637415,8.66547272 1.51889382,8.50067087 L3.52743156,8.50029704 C3.50930542,8.66436816 3.5,8.83109738 3.5,9 C3.5,11.4852814 5.51471863,13.5 8,13.5 C10.4852814,13.5 12.5,11.4852814 12.5,9 C12.5,6.51471863 10.4852814,4.5 8,4.5 C7.83109738,4.5 7.66436816,4.50930542 7.50029704,4.52743156 L7.5,7.5 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          transform="matrix(0 1 1 0 .5 -.5)"
        />
      </g>
    </Icon>
  )
}
